// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import "lib-flexible/flexible.js";
import Moment from "moment";
import waterfall from 'vue-waterfall2'
import vueMeta from 'vue-meta'
import Video from 'video.js'
// import 'video.js/dist/video-js.css'
import weChatApi from './assets/share.js'
// import Vconsole from 'vconsole'
Vue.config.productionTip = false;
Vue.prototype.axios = axios;
Vue.use(Moment);
Vue.use(waterfall)
Vue.use(vueMeta)

// let vConsole = new Vconsole();
// Vue.use(TcPlayer)
Vue.prototype.$video = Video
Vue.prototype.$weChat = weChatApi
    // 定义一个全局后退，如果没有历史记录回到首页
Vue.prototype.$personBack = function() {
    if (window.history.length > 1) {
        this.$router.back(-1)
    } else {
        this.$router.push('/')
    }
}
Vue.filter("formatDate", function(value) {
    return Moment(value).format("YYYY-MM-DD");
});
Vue.filter("format", function(value) {
    return Moment(value).format("YYYY/MM/DD");
});


router.afterEach(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
});
router.beforeEach((to, from, next) => {
    var ua = navigator.userAgent.toLowerCase();
    var uri = location.href;
    console.log(uri);
    if (ua.match(/MicroMessenger/i) != "micromessenger") {
        next()
        return
    }
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        if (sessionStorage.getItem('iosUrl')) {
            uri = sessionStorage.getItem('iosUrl')
        } else {
            sessionStorage.setItem('iosUrl', uri)
        }
    }
    try {
        axios.get('/api/consume/WeiXin/TokenAndTicket?sourceUrl=' + encodeURIComponent(uri)).then(data => {
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，
            if (data) {
                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: 'wx23433c9b0ad93235', // 必填，公众号的唯一标识
                    nonceStr: data.data.noncestr, // 必填，生成签名的随机串
                    signature: data.data.signature, // 必填，签名，见附录1
                    timestamp: data.data.timestamp, // 必填，生成签名的时间戳
                    jsApiList: ["updateAppMessageShareData", "updateTimelineShareData", "onMenuShareAppMessage", "onMenuShareTimeline"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                })
            }
        })
        next()
    } catch (error) {
        next()
    }
})
    /* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    components: { App },
    template: "<App/>"
});


// WEBPACK FOOTER //
// ./src/main.js